import UTIF from 'utif';

/**
 * 是否为 TIFF（含常见误写扩展名 itff）。浏览器无法可靠预览 TIFF，上传七牛前需转 JPEG。
 */
export function isTiffLikeFile(file) {
  if (!file) return false;
  const n = String(file.name || '').toLowerCase();
  if (/\.(tif|tiff|itff)$/i.test(n)) return true;
  const t = String(file.type || '').toLowerCase();
  return t === 'image/tiff' || t === 'image/tif' || t === 'image/x-tiff';
}

/**
 * 将 TIFF 解码为位图后编码为 JPEG。不缩放尺寸；quality=1 为浏览器 JPEG 最高质量（无额外尺寸压缩）。
 */
export async function tiffFileToJpegFile(file) {
  const ab = await file.arrayBuffer();
  const ifds = UTIF.decode(ab);
  if (!ifds || !ifds.length) {
    throw new Error('无法解析 TIFF，请确认文件未损坏');
  }
  const ifd = ifds[0];
  UTIF.decodeImage(ab, ifd);
  const rgba = UTIF.toRGBA8(ifd);
  const w = ifd.width;
  const h = ifd.height;
  if (!w || !h || !rgba || rgba.length < w * h * 4) {
    throw new Error('TIFF 解码失败或尺寸异常');
  }

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('无法创建画布上下文');

  const clamped = new Uint8ClampedArray(rgba);
  ctx.putImageData(new ImageData(clamped, w, h), 0, 0);

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('JPEG 编码失败'))),
      'image/jpeg',
      1.0,
    );
  });

  const baseName = String(file.name || 'image').replace(/\.(tif|tiff|itff)$/i, '');
  return new File([blob], `${baseName || 'image'}.jpg`, { type: 'image/jpeg' });
}
